<template>
<div>
  <h2 class="mb-4">月間スタッフ予定</h2>
  <monthly-schedule-container />
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import MonthlyScheduleContainer from '@/containers/work-schedule/MonthlyScheduleContainer.vue'

export default defineComponent({
  components: {
    MonthlyScheduleContainer,
  },
})

</script>
